import { gql } from '@apollo/client';

export const SPEC_ID_V2_MATCH = gql`
  fragment SpecIdV2Match on SpecIdV2Match {
    id
    outgoingId
    incomingId
    quantity
  }
`;

export const SPEC_ID_V2_MEMBER = gql`
  fragment SpecIdV2Member on SpecIdV2Member {
    id
    groupId
    transferId
    direction
    groupIndex
    transfer {
      id
      userId
      groupId
      type
      direction
      currency
      tokenId
      tokenAddress
      quantity
      # the fee-netted lot size (buy with a same-currency fee); falls back to quantity when null
      specIdTotalQuantity
      price
      valueUsd
      timestamp
      # which pool of lots it belongs to under recalc by account
      accountId
      groupTimestampMax
      hash
      credential {
        credentialType
        address
        name
        integrationName
      }
      createdAt
    }
  }
`;

export const SPEC_ID_V2_GROUP = gql`
  fragment SpecIdV2Group on SpecIdV2Group {
    id
    userId
    createdAt
    updatedAt
    members {
      ...SpecIdV2Member
    }
    matches {
      ...SpecIdV2Match
    }
    parentMatches {
      ...SpecIdV2Match
    }
  }
  ${SPEC_ID_V2_MEMBER}
  ${SPEC_ID_V2_MATCH}
`;
